import moment from 'moment-timezone'
import { DRIVER_LOCATIONS_ACTION_TYPES } from 'utils/actions/driverLocations'

const {
  DRIVER_LOCATIONS_FAILURE,
  DRIVER_LOCATIONS_REQUEST,
  DRIVER_LOCATIONS_SUCCESS,
} = DRIVER_LOCATIONS_ACTION_TYPES

const defaultState = {
  fetching: true,
  error: null,
  driverLocations: null,
}

const userDriverLocationsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case DRIVER_LOCATIONS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null,
      }
    case DRIVER_LOCATIONS_SUCCESS: {
      const {
        payload: { user, users },
      } = action
      let driverLocations

      if (user) {
        const { driverLocations: tempDriverLocations } = user
        driverLocations = tempDriverLocations
      }

      if (users) {
        driverLocations = users
          .reduce((locations, childUser) => {
            const updatedLocations = locations.concat(childUser.driverLocations || [])
            return updatedLocations
          }, [])
          .sort((a, b) => moment(b.createdAt) - moment(a.createdAt))
      }

      return {
        ...state,
        fetching: false,
        error: null,
        driverLocations,
      }
    }
    case DRIVER_LOCATIONS_FAILURE: {
      const { error } = action
      return {
        ...state,
        fetching: false,
        error,
      }
    }
    default:
      return state
  }
}

export default userDriverLocationsReducer
